import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "v-table-h" }

type Row = { title: string, class?: string, fallback?: string, fields?: boolean, map?: (item: any, cell: any) => any }


export default /*#__PURE__*/_defineComponent({
  __name: 'VTableH',
  props: {
    rows: null,
    data: null
  },
  setup(__props: any) {

const props = __props as { rows: { [ key: string ]: Row }, data: any[] }




const getValue = (row: Row, data: any, key: string | number) => {
  if (row.map) {
    return row.map(data, data[key]) ?? row.fallback
  }
  if (row.fields) {
    return data.fields[key] ?? row.fallback
  }
  return data[key] ?? row.fallback
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.rows, (row, key) => {
        return (_openBlock(), _createElementBlock("tr", { key: key }, [
          _createElementVNode("td", {
            class: _normalizeClass(row.class)
          }, _toDisplayString(row.title), 3),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (column, index) => {
            return (_openBlock(), _createElementBlock("td", {
              key: key,
              class: _normalizeClass(row.class)
            }, [
              _renderSlot(_ctx.$slots, key, {
                item: column,
                cell: getValue(row, column, key),
                index: index
              }, () => [
                _createTextVNode(_toDisplayString(getValue(row, column, key)), 1)
              ])
            ], 2))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}
}

})